import { render } from "./NewNote.vue?vue&type=template&id=0bcf4a0a&scoped=true"
import script from "./NewNote.vue?vue&type=script&lang=js"
export * from "./NewNote.vue?vue&type=script&lang=js"

import "./NewNote.vue?vue&type=style&index=0&id=0bcf4a0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcf4a0a"]])

export default __exports__